import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../lib/api";
import { Button } from "../components/ui/button";

const SEV_COLORS = { high: "bg-red-600 text-white", medium: "bg-yellow-600 text-black", low: "bg-neutral-700 text-white" };

export default function Share() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    axios.get(`${API}/share/${token}`).then((r) => setData(r.data)).catch((e) => setErr(e?.response?.data?.detail || "Link not found"));
  }, [token]);

  if (err) return (
    <div className="max-w-xl mx-auto mt-16 text-center">
      <div className="rs-underline mx-auto mb-4" />
      <h1 className="font-display-heavy text-4xl">LINK EXPIRED</h1>
      <p className="text-neutral-400 mt-3">{err}</p>
      <Link to="/"><Button className="mt-8 h-12 px-6 bg-red-600 hover:bg-red-700 font-semibold">Go to REPSNAP</Button></Link>
    </div>
  );
  if (!data) return <div className="text-neutral-400">Loading…</div>;

  const a = data.analysis;
  const result = a.result || {};
  return (
    <div>
      <div className="rs-underline mb-3" />
      <div className="text-xs uppercase text-neutral-400 font-display tracking-widest">Shared with you</div>
      <h1 data-testid="share-heading" className="font-display-heavy text-4xl mt-1">{data.athlete_name.toUpperCase()} · {a.sport.toUpperCase()}</h1>
      <p className="text-neutral-500 mt-1 text-sm">{new Date(a.created_at).toLocaleString()}</p>

      {a.status !== "complete" && (
        <div className="mt-8 border border-neutral-800 rounded-md bg-neutral-900 p-6 text-neutral-400">Analysis is still being reviewed. Check back shortly.</div>
      )}

      {a.status === "complete" && (
        <div className="mt-8 space-y-6">
          {result.summary && (
            <div className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
              <div className="uppercase text-xs text-neutral-400 font-display tracking-widest">Coach's summary</div>
              <p className="mt-2 text-lg text-neutral-100">{result.summary}</p>
            </div>
          )}
          {result.strengths?.length > 0 && (
            <div className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
              <div className="font-display-heavy text-xl mb-3">STRENGTHS</div>
              <ul className="list-disc pl-6 text-neutral-200 space-y-1">{result.strengths.map((s) => <li key={`str-${s.slice(0, 20)}`}>{s}</li>)}</ul>
            </div>
          )}
          <div>
            <div className="font-display-heavy text-2xl mb-3">FIX LIST</div>
            <div className="grid gap-4">
              {(result.issues || []).map((it) => (
                <div key={it.id || it.title} className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <div className="font-display-heavy text-xl">{it.title}</div>
                      <p className="text-neutral-300 mt-2">{it.explanation}</p>
                    </div>
                    <span className={`text-xs uppercase font-display font-bold tracking-widest px-2 py-1 rounded ${SEV_COLORS[it.severity] || SEV_COLORS.medium}`}>{it.severity}</span>
                  </div>
                  {it.drill && (
                    <div className="mt-4 border-t border-neutral-800 pt-4">
                      <div className="uppercase text-xs text-red-500 font-display tracking-widest">Drill</div>
                      <div className="font-display-heavy text-lg mt-1">{it.drill.name}</div>
                      <p className="text-neutral-300 mt-1">{it.drill.description}</p>
                      {it.drill.reps && <p className="text-neutral-400 text-sm mt-2">Suggested: {it.drill.reps}</p>}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <div className="border border-neutral-800 rounded-md bg-neutral-900 p-6 text-center">
            <div className="uppercase text-xs text-neutral-400 font-display tracking-widest">Want feedback like this?</div>
            <Link to="/register"><Button data-testid="share-cta-signup" className="mt-3 h-12 px-6 bg-red-600 hover:bg-red-700 font-semibold">Try REPSNAP free</Button></Link>
          </div>
        </div>
      )}
    </div>
  );
}
